module.exports = __webpack_public_path__ + "static/media/arrow-tab-up.dfba14a8.svg";